"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-add-circle.tsx
var AddCircle = function AddCircle(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M9.16602 14.1663H10.8327V10.8329H14.166V9.16626H10.8327V5.83293H9.16602V9.16626H5.83268V10.8329H9.16602V14.1663ZM9.99935 18.3329C8.84657 18.3329 7.76324 18.1142 6.74935 17.6767C5.73546 17.2392 4.85352 16.6454 4.10352 15.8954C3.35352 15.1454 2.75977 14.2635 2.32227 13.2496C1.88477 12.2357 1.66602 11.1524 1.66602 9.99959C1.66602 8.84682 1.88477 7.76348 2.32227 6.74959C2.75977 5.7357 3.35352 4.85376 4.10352 4.10376C4.85352 3.35376 5.73546 2.76001 6.74935 2.32251C7.76324 1.88501 8.84657 1.66626 9.99935 1.66626C11.1521 1.66626 12.2355 1.88501 13.2493 2.32251C14.2632 2.76001 15.1452 3.35376 15.8952 4.10376C16.6452 4.85376 17.2389 5.7357 17.6764 6.74959C18.1139 7.76348 18.3327 8.84682 18.3327 9.99959C18.3327 11.1524 18.1139 12.2357 17.6764 13.2496C17.2389 14.2635 16.6452 15.1454 15.8952 15.8954C15.1452 16.6454 14.2632 17.2392 13.2493 17.6767C12.2355 18.1142 11.1521 18.3329 9.99935 18.3329Z"
  }));
};

var _default = AddCircle;
exports.default = _default;